// extracted by mini-css-extract-plugin
module.exports = {"SliderPrevButton":"_8WpLJ","SliderNextButton":"cf1aK"};